import loadable from '@loadable/component';
import React from 'react';

export function asyncComponent({ loader, props }) {
  const LoadableComponent = loadable(loader);

  return p => {
    return <LoadableComponent {...p} {...props} />;
  };
}